export enum ButtonType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  TERTIARY = "tertiary",
  DANGER = "danger",
  BLOCK = "block",
  ROUNDED = "rounded",
  SKELETON = "skeleton",
  RED_SKELETON = "red-skeleton",
  GREEN_SKELETON = "green-skeleton",
  GOLD_SKELETON = "gold-skeleton",
  LINK = "link",
  BLACK = "black",
  CANCEL = "cancel",
  LIGHT = "light",
  DASHED = "dashed",
  GREY = "grey",
  GREY_TEXT = "grey-text",
}

export enum ButtonSize {
  XS = "xs",
  S = "s",
  M = "m",
  L = "l",
  XL = "xl",
  XXL = "xxl",
}
